import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FaCalendar, FaUser } from "react-icons/fa";
import SEO from "../common/SEO";
import HeaderOne from "../common/header/HeaderOne";
import SplashFooter from "../common/footer/SplashFooter";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";
import { media_url, useBlog } from "../hooks/useBlog";
import BlogAttachments from "../component/blog/BlogAttachments";
import "./BlogDetails.scss";
import { useSelector } from "react-redux";

const PageDetail = () => {
	const { slug } = useParams();
	const { page } = useBlog();
 	const { currentCustomer } = useSelector((state) => state.store);
	const [viewState, setViewState] = useState({
		page: null,
		loading: true,
	});

	const loadPageFromSlug = async (pageSlug) => {
		if (!pageSlug) return;
		setViewState((prev) => ({ ...prev, loading: true }));
		const pageData = await page.detail(pageSlug);
		if (!pageData) {
			setViewState({ page: null, loading: false });
			return;
		}

		let pageBody = pageData.body || "";
		pageBody = pageBody.replaceAll(/>\s+</g, "><");
		pageBody = pageBody.replaceAll(/<([a-zA-Z0-9]+)(\s+[^>]*)?>\s*<\/\1>/g, "");

		setViewState({
			page: { ...pageData, body: pageBody },
			loading: false,
		});
	};

	useEffect(() => {
		if(currentCustomer && currentCustomer.id) {
			loadPageFromSlug(slug);
		}
		
	}, [slug, currentCustomer]);

	if (viewState.loading || !viewState.page) {
		return (
			<div className="news-article-loading">
				<div className="spinner"></div>
			</div>
		);
	}

	const { page: pageData } = viewState;
	const authorName = pageData.owner?.fullname || "Admin";
	const imageUrl = pageData.image ? media_url(pageData.image) : "";
	const normalizedFiles = Array.isArray(pageData.files)
		? pageData.files
				.map((item) => {
					if (!item) return null;

					if (typeof item === "string") {
						const fileName = item.split("/").pop() || "Archivo";
						return {
							id: item,
							name: fileName,
							file: item,
							is_active: true,
						};
					}

					if (item.file && typeof item.file === "object") {
						return {
							...item.file,
							is_active:
								typeof item.file.is_active === "boolean"
									? item.file.is_active
									: item.is_active ?? true,
						};
					}

					return {
						...item,
						is_active:
							typeof item.is_active === "boolean" ? item.is_active : true,
					};
				})
				.filter((file) => file && file.file)
		: [];

	return (
		<>
			<SEO
				title={pageData.title}
				description={pageData.title}
				author={authorName}
				image={imageUrl}
			/>
			<ColorSwitcher />

			<main className="news-article-wrapper">
				<HeaderOne />

				<div className="news-article-hero">
					<div
						className="news-article-hero-image"
						style={
							imageUrl
								? { backgroundImage: `url(${imageUrl})` }
								: undefined
						}
					>
						<div className="news-article-hero-overlay"></div>
						<div className="news-article-hero-info">
							<h1 className="news-article-hero-title">{pageData.title}</h1>
							<div className="news-article-hero-meta">
								<span>
									<FaUser />
									{authorName}
								</span>
								{pageData.created && (
									<span>
										<FaCalendar />
										{pageData.created}
									</span>
								)}
							</div>
						</div>
					</div>
				</div>

				<div className="news-article-container">
					<div className="news-article-content">
						<div className="container-fluid">
							<div className="row">
								<div className="col-lg-12">
									<div className="news-article-body">
										<div
											dangerouslySetInnerHTML={{ __html: pageData.body }}
										></div>

										{normalizedFiles.length > 0 && (
											<BlogAttachments files={normalizedFiles} />
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<SplashFooter />
			</main>
		</>
	);
};

export default PageDetail;
